import { api } from '../slices/api';

export const extendedApiSlice = api.injectEndpoints({
	endpoints: (builder) => ({
		addMaterialReceived: builder.mutation({
			query: ({ idempotencyKey, ...values }) => ({
				url: 'material/material-received/',
				method: 'POST',
				body: values,
				...(idempotencyKey
					? { headers: { 'Idempotency-Key': idempotencyKey } }
					: {}),
			}),
		}),
		planShortBarReceive: builder.mutation({
			query: (body) => ({
				url: 'material/material-received/short-bar-plan/',
				method: 'POST',
				body,
			}),
		}),
	}),
});

export const {
	useAddMaterialReceivedMutation,
	usePlanShortBarReceiveMutation,
} = extendedApiSlice;
